var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoOperacoes01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#ico-operacoes-2_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ico-operacoes-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -932.6644,
    y1: 552.6574,
    x2: -932.6644,
    y2: 553.3491,
    gradientTransform: "matrix(50.386 0 0 -50.388 47011.2227 27882.7266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9F2FFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0BB1D3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-operacoes-2",
    className: "st0",
    d: "M33.2,5.1h-4.5V3.9c0.6,0,1.1-0.5,1.1-1.1V1.7c0-0.6-0.5-1.1-1.1-1.1h-27 c-0.6,0-1.1,0.5-1.1,1.1v1.1c0,0.6,0.5,1.1,1.1,1.1v11.6l-1.1-1.1v21h22.2L7.3,20.8h15.7v9.6c0,0.9,0.8,1.7,1.7,1.7h9 c0.9,0,1.7-0.8,1.7-1.7V15.8c0-0.9-0.8-1.7-1.7-1.7h-5.1v-3.4h4.5c1.2,0,2.2-1,2.2-2.2V7.3C35.4,6.1,34.4,5.1,33.2,5.1z M17.4,9.1 l-1.8-1.2l1.8-1.2V9.1z M18.6,8.4h12.4v1.1H18.6V8.4z M30.9,7.3H18.6V6.2h12.4V7.3z M1.7,1.7h27v1.1h-27V1.7z M1.7,34.3v-1.1h1.1 v-1.1H1.7v-1.1h1.1v-1.1H1.7v-1.1h1.1v-1.1H1.7v-1.1h1.1v-1.1H1.7v-1.1h1.1v-1.1H1.7v-1.1h1.1v-1.1H1.7v-3.8L20,34.3H1.7z  M34.3,15.8v14.6c0,0.3-0.3,0.6-0.6,0.6h-9c-0.3,0-0.6-0.3-0.6-0.6V15.8c0-0.3,0.3-0.6,0.6-0.6h9C34,15.2,34.3,15.4,34.3,15.8z  M27.6,14.1H18v1.1h5.2c-0.1,0.2-0.1,0.4-0.1,0.6v0.6H18v1.1h5.1v2.2H6.1l-3.3-3.1V3.9h24.7v1.1h-9.7l-4.2,2.8l4.2,2.8h9.7V14.1z  M34.3,8.4c0,0.6-0.5,1.1-1.1,1.1h-1.1V6.2h1.1c0.6,0,1.1,0.5,1.1,1.1L34.3,8.4z M12.4,8.4H9.5l-1.2,9.3l-2.9-3.6H3.9v-1.1h2l1.6,2 l1-7.6h3.9L12.4,8.4z M16.7,11.1l-2.4,2.4l2.4,2.4l-0.8,0.8l-2.4-2.4l-2.4,2.4l-0.8-0.8l2.4-2.4l-2.4-2.4l0.8-0.8l2.4,2.4l2.4-2.4 L16.7,11.1z M26.4,12.9H18v-1.1h8.4V12.9z M3.9,22.3v9.8h10.4L3.9,22.3z M5.1,24.9l6.4,6H5.1V24.9z M33.2,16.3h-7.9v4.5h7.9V16.3z  M32.1,19.7h-5.6v-2.2h5.6L32.1,19.7z M29.8,23.1h3.4v1.1h-3.4V23.1z M28.7,27.6h-3.4v-1.1h3.4V27.6z M28.7,29.8h-3.4v-1.1h3.4V29.8 z M26.4,24.2h-1.1v-1.1h1.1v-1.1h1.1v1.1h1.1v1.1h-1.1v1.1h-1.1V24.2z M33,27.4l-0.7,0.7l0.7,0.7l-0.8,0.8l-0.7-0.7l-0.7,0.7 L30,28.8l0.7-0.7L30,27.4l0.8-0.8l0.7,0.7l0.7-0.7L33,27.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOperacoes01);
export default __webpack_public_path__ + "static/media/ico-operacoes-01.3ba266d11f0b8b2058ce8f1976865dd3.svg";
export { ForwardRef as ReactComponent };